import styled from 'styled-components'

import LeftBar from '../../pages/home/components/leftBar'
import UploadDocumentsPage from './uploadDocuments'

const DIV = styled.div`
    display: flex;
    height: 100vh;
    overflow: hidden !important;
`

const Page = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    scroll-behavior: smooth;
    overflow: auto;
    flex: 1;
`

export default function uploadDocuments() {
    return (
        <DIV>
            <LeftBar />
            <Page>
                <UploadDocumentsPage />
            </Page>
        </DIV>
    )
}
